import {
  //Class Status
  getClassStatusList,
  postClassStatus,
  updateClassStatus,
  deleteClassStatus,

  //ClassStatusMulti
  getClassStatusMultiByClassId,
  postClassStatusMulti,
  updateClassStatusMulti,
  deleteClassStatusMulti,
} from "@/services/class-status.service";

import { formatDateEdit } from "@/utils/utils";

import { setPaginationDetails } from "../../utils/utils";

// initial state
const state = () => ({
  classStatusList: [],
  globalStatusList: [],

  classStatusModel: {},

  centerPeriodStartDate: null,
  centerPeriodEndDate: null,
});

// mutations
const mutations = {
  setClassStatusList(state, data) {
    state.globalStatusList = data;
  },

  setClassStatusModel(state, data) {
    state.classStatusModel = data;
  },

  setCenterPeriodStartDate(state, data) {
    state.centerPeriodStartDate = data;
  },
  setCenterPeriodEndDate(state, data) {
    state.centerPeriodEndDate = data;
  },
};

// actions
const actions = {
  //Class Status
  async loadClassStatus(vuexContext, co) {
    return await getClassStatusList(co).then((response) => {
      let data = response.data.data;
      let totalCount = data.totalCount;
      let totalPages = data.totalPages;
      let items = data.items;

      items.map((item, index) => {
        item.index = index + 1;
        item.label = `${item.startTime} - ${item.endTime} / ${item?.levels?.description}`;
        item.value = item.id;

        if (item.parents?.length > 0) {
          item.parentStatus = "";
          item.parents.forEach((parent, index) => {
            if (index != 0) {
              item.parentStatus += ", ";
            }
            item.parentStatus += `${parent.classStatus?.levels?.description} / ${parent.classStatus?.startTime} - ${parent.classStatus?.endTime}`;
          });
        }

        // if (item.parents) item.parentStatus = `${item.parent.startTime} - ${item.parent.endTime} / ${item.parent?.levels?.description}`;
        // else item.parentStatus = "---";
      });

      // items.sort((a, b) => {
      //   return a.levelsId - b.levelsId;
      // });

      setPaginationDetails(co, totalCount, totalPages);
      return items;
    });
  },

  async postClassStatus(vuexContext, data) {
    return await postClassStatus(data);
  },

  async updateClassStatus(vuexContext, data) {
    return await updateClassStatus(data);
  },

  async deleteClassStatus(vuexContext, data) {
    return await deleteClassStatus(data);
  },

  //ClassStatusMulti
  async loadClassStatusByClassId(vuexContext, classId) {
    return await getClassStatusMultiByClassId(classId).then((response) => {
      let data = response.data.data;
      let items = data.items;
      items.map((item) => {
        item.value = item.id;
        item.startDate = formatDateEdit(item.startDate);
        item.endDate = formatDateEdit(item.endDate);
      });

      items.sort((a, b) => {
        return a.label?.split("-")[0] - b.label?.split("-")[0];
      });

      // vuexContext.commit("setClassStatusList", items)
      return items;
    });
  },

  async postClassStatusMulti(vuexContext, data) {
    return await postClassStatusMulti(data);
  },

  async updateClassStatusMulti(vuexContext, data) {
    return await updateClassStatusMulti(data);
  },

  async deleteClassStatusMulti(vuexContext, data) {
    return await deleteClassStatusMulti(data);
  },

  addGlobalStatusList(vuexContext, data) {
    data.sort((a, b) => {
      return a.label?.split("-")[0] - b.label?.split("-")[0];
    });
    vuexContext.commit("setClassStatusList", data);
  },

  addClassStatusModel(vuexContext, data) {
    vuexContext.commit("setClassStatusModel", data);
  },

  addCenterPeriodStartDate(vuexContext, data) {
    vuexContext.commit("setCenterPeriodStartDate", data);
  },

  addCenterPeriodEndDate(vuexContext, data) {
    vuexContext.commit("setCenterPeriodEndDate", data);
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
